import { inject, injectable } from 'tsyringe';
import { BaseApi } from '../BaseApi';
import { MiddlewareInjectToken } from '../constants/tokens';
import { Apis, MiddlewareConfig } from '../types';
import { StreamingQuotes } from '../types/WebSocket.type';
import { WebSocketOptions, WsHandler } from '../WsHandler';

@injectable()
export class WebSocketApi extends BaseApi {
    constructor(
        @inject(MiddlewareInjectToken.Apis) apis: Apis,
        @inject(MiddlewareInjectToken.Config) config: MiddlewareConfig,
    ) {
        super(apis, config);
    }

    private async getWebSocketUrl(endpoint: string) {
        if (!this.config.websocketUrl) {
            throw new Error('WebSocket url is not provided');
        }

        return `${this.config.websocketUrl}/${endpoint}?auth=${escape(
            'SessionId ' + this.apis.orbis.getApiClient().getAuthData()?.accessToken,
        )}`;
    }

    private async createWsHandler<T>(endpoint: string, options?: WebSocketOptions<T>): Promise<WsHandler<T>> {
        const webSocket = new WsHandler(await this.getWebSocketUrl(endpoint), {
            ...options,
            onReconnect: async (event) => {
                webSocket.updateUrl(await this.getWebSocketUrl(endpoint));
                options?.onReconnect?.(event);
            },
        });

        return webSocket;
    }

    quotes(options?: WebSocketOptions<StreamingQuotes>): Promise<WsHandler<StreamingQuotes>> {
        return this.createWsHandler('stream/json', options);
    }

    equities(options?: WebSocketOptions): Promise<WsHandler> {
        return this.createWsHandler('equities', options);
    }

    orders(options?: WebSocketOptions): Promise<WsHandler> {
        return this.createWsHandler('orders/feed', options);
    }
}
